import styled from 'styled-components';

export const ContainerBackground = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);

  span {
    margin-top: 10px;
    margin-bottom: -10px;
    font-size: 14px;
    color: #f30303;
    font-weight: 700;
  }
`;

export const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
`;

export const ModalContainer = styled.div`
  width: 350px;
  height: 300px;
  border-radius: 12px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ModalBody = styled.div`
  font-size: 16px;
`;

export const InputBlock = styled.div`
  margin: 30px 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  label {
    font-weight: 700;
    color: var(--color-primary);
  }

  input {
    margin-top: 10px;
    width: 240px;
    height: 30px;
    padding: 4px;
    font-size: 14px;
    outline: 0;

    border: 0;
    border-bottom: 2px solid #696868;
  }
`;

export const Button = styled.button`
  margin-top: 10px;
  width: 250px;
  height: 50px;
  border: 0;
  border-radius: 5px;
  background: var(--color-primary);
  color: #fff;
  font-weight: 700;
`;
